import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import { Honeybadger, HoneybadgerErrorBoundary } from '@honeybadger-io/react'
import { AuthProvider, type TAuthConfig, type TRefreshTokenExpiredEvent } from 'react-oauth2-code-pkce'
import { ApolloProvider } from './providers/apollo_provider.tsx'
import { CurrentUserProvider } from './providers/current_user_context'
import { RouterProvider } from 'react-router'
import { router } from './router.tsx'

const authConfig: TAuthConfig = {
  clientId: import.meta.env.VITE_MYSTRO_CLIENT_ID,
  authorizationEndpoint: import.meta.env.VITE_MYSTRO_AUTHORIZATION_ENDPOINT,
  tokenEndpoint: import.meta.env.VITE_MYSTRO_TOKEN_ENDPOINT,
  redirectUri: import.meta.env.VITE_MYSTRO_REDIRECT_URI,
  scope: 'user',
  decodeToken: false,
  onRefreshTokenExpire: (event: TRefreshTokenExpiredEvent) => event.logIn(undefined, undefined, 'popup'),
}

const honeybadgerConfig = {
  apiKey: import.meta.env.VITE_HONEYBADGER_API_KEY,
  environment: import.meta.env.VITE_MYSTRO_ENV || 'production',
  revision: import.meta.env.VITE_VERSION
}

const honeybadger = Honeybadger.configure(honeybadgerConfig)

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HoneybadgerErrorBoundary honeybadger={ honeybadger }>
      <AuthProvider authConfig={ authConfig }>
        <ApolloProvider>
          <CurrentUserProvider>
            <RouterProvider router={ router } />
          </CurrentUserProvider>
        </ApolloProvider>
      </AuthProvider>
    </HoneybadgerErrorBoundary>
  </StrictMode>,
)
